'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (unit) {
    return {
        t: 'Ticks',
        s: 'Seconds',
        m: 'Minutes',
        h: 'Hours',
        d: 'Days'
    }[unit];
};